import { Header, StatsCard } from "@general-backoffice/core";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { Col, Container, Row } from "reactstrap";

import useReferrersHierarchyStats from "../../../../../components/adminStats/hooks/useReferrersHierarchyStats";
import ReferrersStatsTableCard from "../../../../../components/adminStats/ReferrersStatsTableCard";
import useUsers from "../../../../../components/users/hooks/useUsers";

const Distributors: React.FC = () => {
  const { t } = useTranslation("dashboard", { keyPrefix: "adminPages.adminStatsPages.distributors" });
  const navigate = useNavigate();

  const { users: distributors = [] } = useUsers({
    pagination: { page: 1, pageSize: 1 },
    filters: { referrerType: "DISTRIBUTOR", isTest: false },
  });

  const {
    rawReferrersHierarchyStats,
    referrersHierarchyStats = [],
    isLoading: isLoadingReferrersHierarchyStats,
    ...referrersHierarchyProps
  } = useReferrersHierarchyStats({ params: { filters: { referrerType: "DISTRIBUTOR" } } });

  const top5 = useMemo(() => {
    if (!rawReferrersHierarchyStats) return [];
    return [...rawReferrersHierarchyStats]
      .sort((a, b) => (b?.charged?.EUR?.total || 0) - (a?.charged?.EUR?.total || 0))
      .slice(0, 5);
  }, [rawReferrersHierarchyStats]);

  return (
    <React.Fragment>
      <Header.BreadCrumb color="secondary" isDark={false}>
        <Col xs={12} md={6} lg={4}>
          <StatsCard.Number
            color="primary"
            isDark={true}
            number={distributors.length}
            suffix="distributors"
            title={t("distributors")}
            icon="fas fa-bullhorn"
            description="Number of distributors"
          />
          <StatsCard.Number
            color="dark"
            isDark={true}
            number={(rawReferrersHierarchyStats || []).reduce((r, c) => r + (c?.referralsCount || 0), 0)}
            suffix="referrals"
            title={t("referrals")}
            icon="fas fa-bullhorn"
            description="Total users signed by distributors"
          />
        </Col>
        <Col xs={12} md={6} lg={8}>
          <ReferrersStatsTableCard
            pageSize={5}
            pagination={null}
            sort={{ "charged.EUR.total": "down" }}
            title={t("top5")}
            referrers={top5}
            onReferrerClick={({ referrer }) => navigate(`/users/${referrer?.id}`)}
            isLoading={isLoadingReferrersHierarchyStats}
            columnsToHide={[
              "referrerType",
              "badges",
              "inactiveBalance",
              "totalProfit",
              "totalLosses",
              "signIn",
              "buttons",
              "hierarchyCharged",
            ]}
          />
        </Col>
      </Header.BreadCrumb>
      <Container className="mt--6" fluid>
        <Row>
          <Col xl={12}>
            <ReferrersStatsTableCard
              {...referrersHierarchyProps}
              title={t("all")}
              referrers={referrersHierarchyStats}
              totalReferrers={rawReferrersHierarchyStats?.length}
              onReferrerClick={({ referrer }) => navigate(`/users/${referrer?.id}`)}
              isLoading={isLoadingReferrersHierarchyStats}
              filtersToShow={["search", "isVIP"]}
              columnsToHide={["number", "hierarchyCharged"]}
            />
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
};

export default Distributors;
